import DateTime from '@newspaces/zero-base/DateTime';

const getEUUtcOffset = (baseOffset, dateTime, { isUTC = false } = {}) => {
  if (!dateTime) {
    return baseOffset * 60;
  }
  let shiftMonth = -1;
  if (dateTime instanceof DateTime) {
    shiftMonth = 0;
  }
  const { year, month, date, hours, minutes } = dateTime;
  const timestamp = Date.UTC(year, month + shiftMonth, date, hours, minutes, 0, 0);
  let dstBegin;
  if (isUTC) {
    dstBegin = new Date(Date.UTC(year, 2, 31, 1, 0, 0, 0));
  } else {
    dstBegin = new Date(Date.UTC(year, 2, 31, 1 + baseOffset, 0, 0, 0));
  }
  dstBegin.setUTCDate(dstBegin.getUTCDate() - dstBegin.getUTCDay());
  let dstEnd;
  if (isUTC) {
    dstEnd = new Date(Date.UTC(year, 9, 31, 1, 0, 0, 0));
  } else {
    dstEnd = new Date(Date.UTC(year, 9, 31, 2 + baseOffset, 0, 0, 0));
  }
  dstEnd.setUTCDate(dstEnd.getUTCDate() - dstEnd.getUTCDay());
  if (timestamp >= dstBegin.getTime() && timestamp < dstEnd.getTime()) {
    return baseOffset * 60 + 60;
  }
  return baseOffset * 60;
};

const Map = {
  DE: {
    name: "Deutschland",
    getUtcOffsetMinutes: (dateTime, options) => getEUUtcOffset(1, dateTime, options),
    states: {
      BW: { name: "Baden-W\xFCrttemberg" },
      BY: { name: "Bayern" },
      BE: { name: "Berlin" },
      BB: { name: "Brandenburg" },
      HB: { name: "Bremen" },
      HE: { name: "Hessen" },
      HH: { name: "Hamburg" },
      MV: { name: "Mecklenburg-Vorpommern" },
      NI: { name: "Niedersachsen" },
      NW: { name: "Nordrhein-Westfalen" },
      RP: { name: "Rheinland-Pfalz" },
      SL: { name: "Saarland" },
      SN: { name: "Sachsen" },
      ST: { name: "Sachsen-Anhalt" },
      SH: { name: "Schleswig-Holstein" },
      TH: { name: "Th\xFCringen" }
    }
  },
  AT: {
    name: "\xD6sterreich",
    getUtcOffsetMinutes: (dateTime, options) => getEUUtcOffset(1, dateTime, options)
  },
  CH: {
    name: "Schweiz",
    getUtcOffsetMinutes: (dateTime, options) => getEUUtcOffset(1, dateTime, options)
  },
  FR: {
    name: "France",
    getUtcOffsetMinutes: (dateTime, options) => getEUUtcOffset(1, dateTime, options)
  },
  UK: {
    name: "United Kingdom",
    getUtcOffsetMinutes: (dateTime, options) => getEUUtcOffset(0, dateTime, options)
  },
  BE: {
    name: "Belgium",
    getUtcOffsetMinutes: (dateTime, options) => getEUUtcOffset(1, dateTime, options)
  },
  LU: {
    name: "Luxembourg",
    getUtcOffsetMinutes: (dateTime, options) => getEUUtcOffset(1, dateTime, options)
  }
};
const getAsList = () => {
  const result = [];
  Object.keys(Map).forEach((country) => {
    const countryInfo = Map[country];
    if (countryInfo.states) {
      Object.keys(countryInfo.states).forEach((state) => {
        const stateInfo = countryInfo.states[state];
        result.push({
          key: `${country}-${state}`,
          label: `${countryInfo.name} (${stateInfo.name})`
        });
      });
    } else {
      result.push({
        key: country,
        label: countryInfo.name
      });
    }
  });
  return result;
};
const getAsKeys = () => getAsList().map(({ key }) => key);
const getUtcOffsetMinutes = (key, dateTime, options) => {
  if (!key) {
    return 0;
  }
  const [country, state] = key.split("-");
  let getOffset;
  if (state && typeof Map[country].states[state].getUtcOffsetMinutes === "function") {
    getOffset = Map[country].states[state].getUtcOffsetMinutes;
  } else {
    getOffset = Map[country].getUtcOffsetMinutes;
  }
  return getOffset(dateTime, options);
};
const getUtcOffsetString = (key, dateTime, options) => {
  const offsetMinutes = getUtcOffsetMinutes(key, dateTime, options);
  const offsetHours = offsetMinutes / 60;
  if ((/* @__PURE__ */ new Date()).getTimezoneOffset() * -1 === offsetMinutes) {
    return "";
  }
  if (offsetHours > 0) {
    return `GMT+${offsetHours}`;
  }
  if (offsetHours < 0) {
    return `GMT-${Math.abs(offsetHours)}`;
  }
  return "";
};
const getLabel = (key) => {
  const [country, state] = key.split("-");
  if (state && typeof Map[country].states[state].name) {
    return `${Map[country].name} (${Map[country].states[state].name})`;
  }
  return Map[country].name;
};
const AccessCountries = {
  Map,
  getAsList,
  getAsKeys,
  getUtcOffsetMinutes,
  getUtcOffsetString,
  getLabel
};

export { AccessCountries as A };
//# sourceMappingURL=AccessCountries-3e45c6a9.js.map
